@if ((alertService.showPreviewBanner$ | async) && (awsOutageObj$ | async); as awsOutageObj) {
  <app-banner variant="info">
    <span [innerHtml]="previewText ?? awsOutageObj?.safeHtml"></span>
  </app-banner>
}

<arpio-center-panel>
  <div>
    <h1 class="alert-header">Alerts</h1>
    <app-alerts-editor
      [awsOutageItem]="awsOutageObj$ | async"
      (previewTextChange)="onPreviewTextChange($event)"
      (showBanner)="onshowBannerChange($event)"
    >
    </app-alerts-editor>
  </div>
</arpio-center-panel>
